export interface UserVeriffVerificationStatus {
  verified?: boolean;
  status?: VeriffStatus;
}

export enum VeriffStatus {
  STARTED = 'STARTED',
  VERIFIED = 'VERIFIED',
  EXPIRED = 'EXPIRED',
  DECLINED = 'DECLINED',
  //TODO: seems to be impossible to get this status
  COMPLETED = 'COMPLETED',
}
